<template>
  <v-dialog v-model="dialog" max-width="600">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="10">
            {{ title }}
          </v-col>

          <v-col class="text-right">
            <v-btn depressed icon @click="cancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <b>
          {{ error.message }}
        </b>

        <template v-if="errorDetails.length">
          <ul>
            <li v-for="(error, i) in errorDetails" :key="i">
              {{ error.message }} <a
              v-if="error.link" :href=error.link.linkUrlPart>{{ error.link.linkText }}
            </a>
            </li>
          </ul>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorDialog',
  data() {
    return {
      dialog: false,
      title: 'Chyba',
      error: {},
      resolve: null,
      reject: null,
    };
  },
  computed: {
    errorDetails() {
      if (this.error.errorDetails && this.error.errorDetails.length) {
        return this.error.errorDetails.filter((error) => error.message);
      }
      return [];
    },
  },
  methods: {
    open(title, error) {
      this.dialog = true;
      this.title = title || this.title;
      this.error = error;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
